module.exports = __webpack_public_path__ + "static/media/actionresponse-budget.b8425953.svg";